import api from 'Application/api/api';

const getDriveFolderUrl = (signal, id) =>
	api.get(`/projects/get-drive-folder-url/${id}`, {
		signal,
	});

export default getDriveFolderUrl;
